import * as React from 'react'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'

import { CountryAirports } from '../../../data/models/funnelOrder/airport'
import { getAirportNames } from '../../../data/models/funnelOrder/summary'
import { SiteCountry } from '../../../data/models/locale'
import { AppState } from '../../../data/state'

interface AirportSummaryProps {
  airports: CountryAirports[]
  country: SiteCountry
  loading: boolean
}

const AirportSummary: React.FC<AirportSummaryProps> = ({
  airports,
  country,
  loading,
}) => {
  const loadingClass = loading ? 'is-loading' : ''
  return (
    <ListItem>
      <span className={loadingClass}>
        {getAirportNames(new Map(airports).get(country) || [])}
      </span>
    </ListItem>
  )
}

export default connect((state: AppState) => ({
  airports: state.funnelOrder.airports,
  country: state.locale.country,
  loading: state.contentEngine.loading,
}))(AirportSummary)
